import { getQueryParameters, saveBlobAsFile } from 'HELPERS'
import { ABS_TILESERVER_URL } from '@/config/constants'
import { GET, GET_BLOB, POST } from 'API'
import { sendNotify } from 'NOTIFICATION'
import i18n from '@/extensions/i18n'

export const GET_DT_ROOT_ENDPOINT = () => {
  const query = getQueryParameters()

  return query.modificationId ? `modeling` : `digital_twin`
}

export const GET_MODELING_ROOT_ENDPOINT = () => {
  return `modeling`
}

export const GET_LOGISTIC_MODELING_ENDPOINT = ({
  modelId,
  layerId,
  objectId
} = {}) => {
  let url = 'simlog'

  if (modelId) url += `/models/${modelId}`

  if (layerId) url += `/${layerId}`

  if (objectId) url += `/${objectId}`

  return url
}

export const GET_IMPORT_MODEL_URL = module => {
  switch (module) {
    case 'modeling':
      return `${GET_MODELING_ROOT_ENDPOINT()}/models/import`
    case 'digitalTwin':
      return `${GET_DT_ROOT_ENDPOINT()}/models/import`
    case 'logisticModeling':
      return `${GET_LOGISTIC_MODELING_ENDPOINT()}/models/import_json`
  }
}

export const GET_TILESERVER_ROOT_ENDPOINT = () => {
  return `tileserver`
}

export const GET_TR_SIT_QUALITY_SCORE_FULL_URL = ({ byDay } = {}) => {
  return `${GET_TR_SIT_ROOT_ENDPOINT()}/quality/score${
    byDay ? '/' + byDay : ''
  }`
}

export const GET_TILESERVER_FULL_URL = ({
  modelId,
  layerId,
  tableName,
  prevTable,
  hidePrevTable
}) => {
  // используется tableName или modelId_layerId
  const query = getQueryParameters()
  const modificationId = query.modificationId

  const preparedLayerId = layerId?.includes('traffic.')
    ? layerId.replace('traffic.', '')
    : layerId

  const isTrafficLinks = preparedLayerId?.includes('traffic_links')

  const customTableName = modelId ? `${modelId}_${layerId}` : preparedLayerId
  // eslint-disable-next-line vue/max-len
  const base = `${ABS_TILESERVER_URL}/${GET_TILESERVER_ROOT_ENDPOINT()}/tiles/WebMercatorQuad`

  const newVersionUrl = `/${isTrafficLinks ? 'traffic' : 'modeling'}.${
    tableName || customTableName
  }${modificationId ? '_' + modificationId : ''}/{z}/{x}/{y}`

  return base + newVersionUrl
}

export const GET_TR_SIT_ROOT_ENDPOINT = () => {
  return `transport_situation`
}

export const downloadExportedFile = async ({ id, filename }) => {
  const { data } = await GET_BLOB(
    `digital_twin/exported_files/${id}/download`,
    null,
    filename
  )

  saveBlobAsFile(data, filename)
}

export const prepareFileForDownload = async ({ isPost, url, body, query }) => {
  let res

  if (isPost) {
    const { data } = await POST(url, body, query)
    res = data
  } else {
    const { data } = await GET(url, query)
    res = data
  }

  const taskId = res?.task_id

  if (taskId) {
    sendNotify({
      title: i18n.t('file-is-being-processed'),
      message: `${i18n.t(
        'you-will-receive-notification-when-finished'
      )} ${taskId}`
    })
  }
}
